import React from "react";

function RTCVideo({
  style,
  stream,
  zOrder,
  objectFit,
  mirror,
  muted,
  ...props
}: {
  style: any;
  stream: MediaProvider;
  mirror: boolean;
  zOrder: number;
  objectFit: "contain" | "cover";
  muted?: boolean;
}) {
  return (
    <video
      ref={(ref) => {
        if (ref && ref.srcObject !== stream) {
          ref.srcObject = stream;
        }
      }}
      autoPlay
      playsInline
      muted={muted}
      style={{
        zIndex: zOrder,
        objectFit: objectFit,
        transform: mirror ? "scaleX(-1)" : "none",
        ...style,
      }}
      {...props}
    />
  );
}

// We need to check if window is defined - otherwise the code will break
// when we run it on the server in order to generate static HTML
export const MediaStream =
  typeof window !== "undefined" ? window.MediaStream : undefined;
export const MediaStreamTrack =
  typeof window !== "undefined" ? window.MediaStreamTrack : undefined;
export const RTCErrorEvent =
  typeof window !== "undefined" ? window.RTCErrorEvent : undefined;
export const RTCIceCandidate =
  typeof window !== "undefined" ? window.RTCIceCandidate : undefined;
export const RTCPeerConnection =
  typeof window !== "undefined" ? window.RTCPeerConnection : undefined;
export const RTCRtpReceiver =
  typeof window !== "undefined" ? window.RTCRtpReceiver : undefined;
export const RTCRtpSender =
  typeof window !== "undefined" ? window.RTCRtpSender : undefined;
export const RTCRtpTransceiver =
  typeof window !== "undefined" ? window.RTCRtpTransceiver : undefined;
export const RTCSessionDescription =
  typeof window !== "undefined" ? window.RTCSessionDescription : undefined;
export { RTCVideo };
export const mediaDevices =
  typeof window !== "undefined" ? window.navigator.mediaDevices : undefined;
